export const CURRENCY_CONFIG_CODE = 'BRL';
export const CURRENCY_CONFIG_SYMBOL = 'symbol-narrow';
export const CURRENCY_CONFIG_FORMAT_DECIMAL2 = '1.2-2';
export const COUNTRY = 'pt-BR';
export const DATE_CONFIG = 'dd/MM/yyyy';
export const PERCENT_CONFIG_SYMBOL_DECIMAL2 = '1.2-2';
